import React from 'react';
import imgLogo from '../../../assets/img/logo.png';
import {I18nUtils} from "../../../i18n/I18nUtils";
import {Checkbox} from "material-ui";
import {connect} from "react-redux";
import Card from "../../shared/components/Card";
import CardBody from "../../shared/components/CardBody";
import {bindActionCreators} from "redux";
import * as authActions from '../actions/authActions';
import Row from "../../shared/components/Row";
import {isEmailValid} from "../../shared/utils/StringUtils";
import {PsRoutes} from "../../shared/routing/Routes";
import {Link} from "react-router-dom";

class LoginScreen extends React.Component {

  constructor(props){
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    document.body.classList.add('login-page')
  }

  componentWillUnmount() {
    document.body.classList.remove('login-page')
  }

  onSubmit(event){
    event.preventDefault();
    this.props.authActions.login(this.props.email, this.props.password, this.props.remember);
  }

  render() {
    return (
      <div className="login-box">
        <div className="logo">
          <img src={imgLogo} alt="Pavasal" className="img-responsive center-block m-b-15"/>
          <small>{I18nUtils.tr('TR_BIENVENIDO_AL_SISTEMA_DE_GESTION_DE_DOCUMENTACION')}</small>
        </div>
        <Card loading={this.props.loading}>
          <CardBody>
            <form onSubmit={this.onSubmit}>
              <div className="msg">{I18nUtils.tr('TR_ABRIR_SESSION')}</div>
              <div className="input-group">
                <span className="input-group-addon">
                  <i className="material-icons">person</i>
                </span>
                <div className="form-line">
                  <input
                    test-id="login-email"
                    type="text"
                    className="form-control"
                    placeholder={I18nUtils.tr('TR_EMAIL_O_NOMBRE_DE_USUARIO')}
                    required
                    autoFocus
                    value={this.props.email}
                    onChange={(event) => {
                      this.props.authActions.changeEmail(event.target.value)
                    }}
                  />
                </div>
              </div>
              <div className="input-group">
                <span className="input-group-addon">
                  <i className="material-icons">lock</i>
                </span>
                <div className="form-line">
                  <input
                    test-id="login-password"
                    type="password"
                    className="form-control"
                    placeholder={I18nUtils.tr('TR_CONTRASENA')}
                    required
                    onChange={(event) => this.props.authActions.changePassword(event.target.value)}
                  />
                </div>
              </div>
              <Row>
                <div className="col-xs-8 p-t-5">
                  <Checkbox
                    checked={this.props.remember}
                    onClick={(event) => {
                      this.props.authActions.changeRemember(event.target.checked);
                    }}
                    label={I18nUtils.tr('TR_RECUERDAME')}
                    iconStyle={{fill: 'gray'}}
                  />
                </div>
                <div className="col-xs-4">
                  <button
                      test-id="login-submit"
                      disabled={!this.props.btnEnabled}
                      className="btn btn-block bg-blue-grey waves-effect"
                      type="submit"
                      children={I18nUtils.tr('TR_LOGIN').toUpperCase()}
                  />
                </div>
              </Row>
              <Row>
                <div className="col-md-12">
                  <p className={'text-error'}>{this.props.error}</p>
                </div>
              </Row>
              <div className="row m-t-15 m-b-5">
                <div className="col-xs-12 align-right">
                  <Link to={PsRoutes.PASSWORD_RECOVER} >
                    {I18nUtils.tr('TR_OLVIDASTE_TU_CONTRASENA')}
                  </Link>
                </div>
              </div>
            </form>
          </CardBody>
        </Card>
      </div>
    );
  }

}

const mapStateToProps = state => {
  const btnEnabled = state.auth.email && isEmailValid(state.auth.email) && state.auth.password;
  return({
    loading: state.auth.loading,
    email: state.auth.email,
    password: state.auth.password,
    remember: state.auth.remember,
    error: state.auth.error,
    btnEnabled,
  });
};

const mapDispatchToProps = dispatch => ({
  authActions: bindActionCreators(authActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginScreen);



// WEBPACK FOOTER //
// ./src/app/login/screens/LoginScreen.js